import { ApprovedIcon } from '@/assets/icons/info-icons/approved';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface IEditInvestorSuccessDialogProps {
  isOpen: boolean;
  description: React.ReactNode;
  onClose: () => void;
}

const EditInvestorSuccessDialog = ({ isOpen, description, onClose }: IEditInvestorSuccessDialogProps) => {
  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      confirmButton={{
        name: 'OK',
        onClick: onClose,
        disabled: false
      }}
      showCancelButton={false}
    >
      <ModalBody>
        <ApprovedIcon width={60} height={60} />
        <ModalTitle>Success</ModalTitle>
        <ModalDescription>{description}</ModalDescription>
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default EditInvestorSuccessDialog;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const ModalTitle = styled.h2`
  text-align: center;
  font-size: 33px;
  font-weight: 400;
  line-height: 46.2px;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 16px;
  font-style: normal;
  text-align: center;
  line-height: 22.4px;
  color: ${themeVar('font.base')};
`;
